export default Object.freeze({
  // Actual: último arriba (CreatedDate DESC)
  LastAddedFirst: 'last-added-first',
  // FIFO: primero que entró, primero se muestra (CreatedDate ASC)
  LastAddedLast: 'last-added-last',
  //CustomByColumn // Orden fijo por columna específica
});
